export default __webpack_public_path__ + "static/media/icon_fonts_colors.f598bc13.svg";